import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

private readonly notificationState = signal<{ notificationMessage: string, isOpen: boolean, notificationType: any }>({
  notificationMessage:'',
  isOpen: false,
  notificationType: ''
  });

  notificationState$ = toObservable(this.notificationState);

  showNotification( notificationMessage: string, notificationType: any) {
    this.notificationState.set({ notificationMessage: notificationMessage,  isOpen: true, notificationType: notificationType});
  }

  closeNotification() {
    this.notificationState.set({ notificationMessage: '',  isOpen: false, notificationType: ''});
  }
}

export enum ToastType {
  Success,
  Warning,
  Error,
  Highlight,
  Notification
}

